import api from './../libs/api';

export default {

  getPurchases: (params = {}) => {
    return new Promise((resolve, reject) => {
      api()
        .get('/purchases', { params })
        .then(({ status, data }) => {
          if (status === 200) {
            // Ensure returns are included in the response
            const purchasesWithReturns = data.data.map(purchase => ({
              ...purchase,
              returns: purchase.returns || []
            }));
            resolve({
              data: purchasesWithReturns,
              meta: data.meta,
              links: data.links
            });
          }
          throw new Error(`Failed with status: ${status}`);
        })
        .catch(error => reject(error));
    });
  },

  getPurchase: (id) => {
    return new Promise((resolve, reject) => {
      api()
        .get(`/purchases/${id}`)
        .then(({ status, data }) => {
          if (status === 200) resolve(data.data);
          throw new Error(`Failed with status: ${status}`);
        })
        .catch(error => reject(error));
    });
  },

  purchaseLead: (purchase) => {
    console.log('purchase', purchase);
    return new Promise((resolve, reject) => {
      api()
        .post(`/leads/${purchase.leadId}/purchase`, { 
          payment_method_id: purchase.paymentMethodId 
        })
        .then(({ status, data }) => {
          if (status === 201) resolve(data);
          throw new Error(`Failed with status: ${status}`);
        })
        .catch(error => reject(error));
    });
  },

  bulkPurchaseLeads: (purchase) => {
    console.log('bulk purchase', purchase);
    
    const payload = {
      lead_ids: purchase.leadIds,
      is_agreed: purchase.is_agreed
    };

    // Only include payment method if provided
    if (purchase.paymentMethodId) {
      payload.payment_method_id = purchase.paymentMethodId;
    }

    // Include promo code if provided
    if (purchase.promoCode) {
      payload.promoCode = purchase.promoCode;
    }

    return new Promise((resolve, reject) => {
      api()
        .post('/leads/bulk-purchase', payload)
        .then(({ status, data }) => {
          if (status === 201) {
            resolve(data);
          } else {
            reject(new Error(`Failed with status: ${status}`));
          }
        })
        .catch(error => reject(error));
    });
  },
  

  downloadLead: (purchaseId) => {
    return new Promise((resolve, reject) => {
      api()
        .get(`/purchases/${purchaseId}/download`, { responseType: 'blob' })
        .then(({ status, data }) => {
          if (status === 200) resolve(data);
          throw new Error(`Failed with status: ${status}`);
        })
        .catch(error => reject(error));
    });
  },

  getPurchaseHistory: () => {
    return new Promise((resolve, reject) => {
      api()
        .get(`/purchase-history`)
        .then(({ status, data }) => {
          if (status === 200) resolve(data);
          throw new Error(`Failed with status: ${status}`);
        })
        .catch(error => reject(error));
    });
  },

  
};
